var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar9 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 90,
  height: 90,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-9_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0CA092",
  d: "M90 45C90 20.147 69.853 0 45 0S0 20.147 0 45s20.147 45 45 45 45-20.147 45-45"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDC500",
  d: "m31.362 60.626-1.747-1.747-1.748-1.748s-3.454-.45-6.154 3.353c-2.7 3.802-2.205 8.501-2.205 8.501s4.699.495 8.502-2.205c3.802-2.704 3.352-6.154 3.352-6.154"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D13346",
  d: "m36.016 59.918-7.437-7.437-2.97 2.393 8.014 8.014z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EEE",
  d: "M70.494 18.004s-14.689-.878-28.061 11.025C29.06 40.93 25.682 52.688 25.682 52.688s3.07 2.264 5.467 4.66L70.498 18z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#26517F",
  d: "M12.068 50.843s5.622-12.368 20.198-10.56c14.576 1.803-6.109 11.032-6.109 11.032s-4.582-3.371-14.089-.469z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D6D6D6",
  d: "M70.493 18.004s.878 14.689-11.025 28.061C47.566 59.438 35.81 62.816 35.81 62.816s-2.265-3.071-4.662-5.467L70.498 18z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E3A54",
  d: "M37.654 76.429s12.368-5.621 10.56-20.198c-1.804-14.576-11.032 6.11-11.032 6.11s3.37 4.582.468 14.088z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#26517F",
  d: "M43.858 44.64s-6.03 2.527-11.31 7.807-7.808 11.31-7.808 11.31z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E3A54",
  d: "M43.858 44.64s-2.528 6.03-7.808 11.31-11.31 7.807-11.31 7.807z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDC500",
  d: "M51.928 41.449a4.879 4.879 0 1 0 0-9.758 4.879 4.879 0 0 0 0 9.758"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D13346",
  d: "m59.742 28.755 10.751-10.751s-8.074-.477-17.7 4.125a200 200 0 0 1 6.949 6.626"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A51C34",
  d: "m59.742 28.755 10.751-10.751s.477 8.073-4.125 17.7a200 200 0 0 0-6.626-6.95"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-9_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h90v90H0z"
})))));
export { SvgAvatar9 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-9.4c00532542342fdd35b3.svg";